export default __webpack_public_path__ + "static/media/mobile_apps.e6027e34.png";